import Joi from '@hapi/joi'

export const FactoryItemRequestApprovalFillteringSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().required().label("Collection Point").messages({
        "any.invalid": `Collection Point cannot have invalid characters`,
        "any.required": `Collection Point required`
    }),

    customerID: Joi.number().required().label("Customer ID").messages({
        "any.invalid": `Customer ID cannot have invalid characters`,
        "any.required": `Customer ID required`
    })
}

export const FactoryItemRequestApprovalUpdateSchema = {

    factoryItemName: Joi.string().allow("", null).label("Factory Item Name"),

    factoryItemCode: Joi.string().allow("", null).label("Factory Item Code"),

    firstName: Joi.string().allow("", null).label("Customer Name"),

    cardNumber: Joi.string().allow("", null).label("Card Number"),

    requestedQuantity: Joi.string().allow("", null).label("Request Amount"),

    createdDate: Joi.string().allow("", null).label("Requested Date"),

    reason: Joi.string().allow("", null).label("Reason"),

    approvedQuantity: Joi.string().allow("", null).label(" Approved Quantity"),

    
}